import {type MaterialStorage, type StorageWithMaterial} from '@domain/material-storage'

export const isStorageWithMaterialGuard = (
  storage: MaterialStorage
): storage is StorageWithMaterial => storage.materialId !== null
